import styled from "styled-components";

export const Container = styled.div`
  margin-bottom: 40px;
`;

export const StepCardContainer = styled.div`
  margin: 30px 0 16px 0;
  width: 100%;
`;

export const DividerContainer = styled.div`
  margin: 50px 0;
  width: 100%;
`;

export const SituationsContainer = styled.div<{ isVisible: boolean }>`
  display: flex;
  padding: 40px;
  flex-direction: column;
  gap: 8px;
  border: 1px solid ${({ theme }) => theme.colors.grey100};
  display: ${({ isVisible }) => (isVisible ? "true" : "none")};
`;

export const DomainCards = styled.div`
  margin-bottom: 8px;
`;

export const SearBarContainer = styled.div`
  width: 100%;
  margin: 24px 0 0 0;
`;

export const ResultsBlocContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 56px 0;
  width: 100%;
`;
